import styled from 'styled-components'

export const CardHolder = styled.div`
  &:first-child {
    border-top: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
  }

  border-bottom: 1px solid ${({ theme }) => theme.webMktNewPalette.deepBlue[30]};
  padding: 24px 16px 16px 16px;
`

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;

  .CardHeader__City {
    line-break: auto;
  }

  .Link-MapUrl {
    display: flex;
    min-width: 74px;
    margin-left: 8px;
  }
`

export const CardSubHeader = styled.div`
  margin-top: 8px;
  .CardSubHeader__Country {
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
  }
`

export const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 16px;
`

export const RowItem = styled.div`
  display: flex;
  align-items: flex-start;

  .RowItem-Name {
    display: flex;
    width: 57px;
    margin-right: 16px;
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[45]};
  }

  .Address {
    margin-top: 8px;
  }

  .Phone {
    margin-top: 13px;
  }

  .Email {
    margin-top: 13px;
  }

  .RowItem-Content {
    display: flex;
    color: ${({ theme }) => theme.webMktNewPalette.deepBlue[55]};
  }
`
export const CardFooter = styled.div`
  display: flex;
  padding: 12px 0px 8px 73px;

  .CardFooter__Link {
    color: ${({ theme }) => theme.webMktNewPalette.action.light.primary};
  }
`
